<template>
  <div id="app">
    <nav>
      <div class="logo">:OR</div>
      <router-link to="/">Home</router-link>
      <router-link to="/rooms">Rooms</router-link>
      <router-link to="/about">About</router-link>
      <i class="fas fa-search search"></i>
    </nav>
    <main>
      <Loading :isLoading="isLoading"></Loading>
      <router-view />
    </main>
    <footer>
      <div class="info">
        <div class="logo">:OR</div>
        <div class="contact-info">
          <div class="address">
            <i class="fas fa-map-marker-alt"></i>50 Nathan Road, Tsimshatsui, Kowloon Hong Kong
          </div>
          <div class="tel">
            <i class="fas fa-phone-alt"></i>+886 932 379 080
          </div>
          <div class="mail">
            <i class="fas fa-envelope"></i>or_hotel@gmail.com
          </div>
        </div>
        <div class="footerNav">
          <router-link to="/">Home</router-link>
          <router-link to="/rooms">Rooms</router-link>
          <router-link to="/about">About</router-link>
        </div>
        <div class="social-media">
          <i class="fab fa-facebook"></i>
          <i class="fab fa-twitter-square"></i>
          <i class="fab fa-instagram"></i>
        </div>
      </div>
      <div class="copyright">Copyright &copy; 2019 :OR All Rights Reserved.</div>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Nav from "@/components/Nav.vue";
import Foot from "@/components/Foot.vue";
import Loading from "@/components/Loading.vue";
export default {
  created() {},
  components: { Nav, Foot, Loading },
  computed: {
    ...mapState(["isLoading"])
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

html {
  --fs: 16px;
  --fs-s: calc(var(--fs) * 0.75);
  --fs-m: calc(var(--fs) * 1);
  --fs-l: calc(var(--fs) * 1.5);
  --fs-xl: calc(var(--fs) * 2);
  --fs-xxl: calc(var(--fs) * 2.5);

  --g: 10px;
  --g-s: calc(var(--g) * 0.5);
  --g-m: calc(var(--g) * 1);
  --g-l: calc(var(--g) * 1.5);
  --g-xl: calc(var(--g) * 2);
  --g-xxl: calc(var(--g) * 2.5);

  --text-color: black;
  --text-color-lighter: rgb(100, 100, 100);
  --text-color-lightest: rgb(150, 150, 150);
  --text-color-darker: rgb(50, 50, 50);

  --bannerHeight: 54px;

  --color-bck: rgb(230, 230, 230);
  --color-warn: rgb(255, 230, 233);
  --color-alert: rgb(255, 138, 138);
}

#app {
  font-family: "Hind", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

nav {
  padding: var(--g-l) var(--g-xl);
  box-shadow: 0 0 3px var(--text-color-lightest);
  display: flex;
  flex-flow: row wrap;
  background: linear-gradient(white 0%, transparent);
  width: 100%;
  justify-content: flex-end;
  .logo {
    margin-right: auto;
  }
  .search {
    margin-left: var(--g-l);
    align-self: center;
  }
}
main {
  min-height: calc(100vh - var(--bannerHeight));
  display: flex;
  justify-content: center;
  // align-items: center;
}
article {
  padding: var(--g-xxl);
}
a {
  align-self: center;
  text-decoration: none;
  margin: 0 var(--g-m);
  color: var(--text-color);
  text-transform: uppercase;
  font-weight: bold;
  font-size: var(--fs-m);
}
.router-link-exact-active {
  text-decoration: underline;
}

footer {
  padding: calc(2 * var(--g-l));
  background-color: var(--color-bck);
}
.info {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  > div {
    margin-right: var(--g-m);
    margin-bottom: var(--g-m);
  }

  .contact-info,
  .footerNav {
    display: flex;
    flex-flow: column wrap;
  }
  .contact-info {
    font-size: var(--fs-s);
    i {
      width: var(--fs-l);
      padding: 0;
    }
  }
  .footerNav {
    a {
      font-size: var(--fs-s);
      align-self: auto;
    }
  }
  .social-media {
    display: flex;
    flex-flow: row wrap;
  }
  div > * {
    padding: var(--g-s);
  }
}
.copyright {
  padding-top: calc(2 * var(--g-xl));
  text-align: right;
  font-size: var(--fs-s);
}
h1 {
  font-size: var(--fs-l);
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: var(--g-m);
  color: var(--text-color);
}

p {
  font-size: var(--fs-m);
  line-height: 1.5em;
  color: var(--text-color-lighter);
  margin-bottom: var(--g-m);
}

.logo {
  font-size: var(--fs-l);
  font-weight: bolder;
  align-self: center;
}
</style>
